import React from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ApplicantProfileTabs from "../Contents/ApplicantProfile/ApplicantProfileTabs";
import ReviewerInputs from "../Contents/Reviewer/ReviewerInputs";

function Reviewer() {



  const names = [
    "Sadeeq Fahass",
    "Farouq Umar",
    "Adbulazeez Sani",
    "Umar Idris",
    "Ibrahim Abubakar",
    "Sulaiman Kabir",
    "Umar Idris",
    "Sadeeq Fahass",
    "Umar Idris",
    "Sadeeq Fahass",
    "Adbulazeez Sani",
    "Umar Idris",
    "Ibrahim Abubakar",
    "Sulaiman Kabir",
    "Umar Idris",
    "Sadeeq Fahass",
    "Umar Idris",
    "Ibrahim Abubakar",
    "Sulaiman Kabir",
    "Umar Idris",
    "Sadeeq Fahass",
    "Umar Idris",
    "Sadeeq Fahass",
    "Adbulazeez Sani",
    "Umar Idris",
    "Ibrahim Abubakar",
    "Sulaiman Kabir",
    "Umar Idris",
    "Ibrahim Abubakar",
    "Sulaiman Kabir",
    "Umar Idris",
    "Sadeeq Fahass",
    "Umar Idris",
    "Sadeeq Fahass",
    "Adbulazeez Sani",
    "Umar Idris",
    "Ibrahim Abubakar",
    "Sulaiman Kabir",
  ];


  

  return (
    <div>
        {/* <h1 className="text-center font-bold text-2xl">Reviewer</h1> */}
      <div className="h-[91vh] d-flex items-start ">
        <div
          style={{ height: "37.5rem" }}
          className="verification-aside w-1/4  bg-slate-100 overflow-auto"
        >
          <ul className="ver-aside-ul">
            {names.map((name, index) => (
              <li key={index}>
                {" "}
                <AccountCircleIcon /> {name}
              </li>
            ))}
          </ul>
        </div>

        <div style={{ height: "37.5rem" }} className="overflow-auto w-full ">
            {/* <ApplicantProfileTabs /> */}
            <ReviewerInputs />
        </div>
      </div>
    </div>
  );
}

export default Reviewer;
